"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectPlayer = void 0;
const PlayerInputTypes_1 = require("../PlayerInputTypes");
class SelectPlayer {
    constructor(players, title, buttonLabel = 'Save', cb) {
        this.players = players;
        this.title = title;
        this.buttonLabel = buttonLabel;
        this.cb = cb;
        this.inputType = PlayerInputTypes_1.PlayerInputTypes.SELECT_PLAYER;
        this.buttonLabel = buttonLabel;
    }
}
exports.SelectPlayer = SelectPlayer;
//# sourceMappingURL=SelectPlayer.js.map